import { TagApi } from './tagApi'

function list () {
    return TagApi.list().then(response => response.data)
}

function toggleTag (serialNumber, toggle) {
    return TagApi.toggleTag(serialNumber, toggle)
}

function listReplaceTag() {
    return TagApi.listReplaceTag().then(response => response.data)
}

function replaceTag (oldSerialNumber, newSerialNumber) {
    return TagApi.replaceTag(oldSerialNumber, newSerialNumber)
}

function getGeneratedQty (companyId) {
    return TagApi.getGeneratedQty(companyId)
}

function downloadQrCodeTag (companyId, qrCodeQty) {
    return new Promise(function(resolve, reject) {
        TagApi.downloadGeneratedTag(companyId, qrCodeQty)

        resolve("Ok!")
    })
}

function exportQrCodeTag (companyId, qrCodeQty) {
    return new Promise(function(resolve, reject) {
        TagApi.exportGeneratedTag(companyId, qrCodeQty)

        resolve("Ok!")
    })
}

function exportActiveTags() {
    return new Promise(function(resolve, reject){
        TagApi.exportActiveTags()

        resolve("Ok!")
    })
}

function exportSelectedTags(serialNumbers) {
    return TagApi.exportSelectedTags(serialNumbers).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'tags_selecionadas.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    })
}

export const TagService = { list, toggleTag, listReplaceTag, replaceTag, getGeneratedQty, downloadQrCodeTag, exportQrCodeTag, exportActiveTags, exportSelectedTags }
